import axios from 'axios'

export class ConteudoAplicado {
  static async getConteudoAplicado(ano, turma_id, disciplina_id, mes) {
    return axios.get(`/conteudo-aplicado/${ano}/${turma_id}/${disciplina_id}/${mes}`)
  }
}
